import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-create-pass',
  templateUrl: 'create-pass.html',
})
export class CreatePassPage {

  dataSms: any;
  date: Date;
  date_time: string;
  duration: number;
  image = null;
  message: string;
  mobile: string;
  name: string;
  purpose: string;
  residentId: number;
  status: number;
  time: string;
  valid_days = [];
  address: string;
  editPass = false;
  showPass = false;
  passNo: number;

  days = [
    {val:"sun", isChecked: false},
    {val:"mon", isChecked: false},
    {val:"tue", isChecked: false},
    {val:"wed", isChecked: false},
    {val:"thus", isChecked: false},
    {val:"fri", isChecked: false},
    {val:"sat", isChecked: false}];

  user_info: any;
  isToggled = false;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private storage: Storage,
    private visitorProvider: VisitorProvider, 
    private toast: ToastProvider,
    private loadingCtrl: LoadingController) {
    this.storage.get("loginDetails").then(val => {
      this.user_info = val;
    });

    if(this.navParams.get("showPass"))
      this.showPass = true;

    let data = this.navParams.get("passDetails");
    console.log("data-", data);

    if(data){
      this.editPass = true;
      this.date_time = data.date_time,
      this.time = data.date_time.slice(11,-3);
      let date = data.date_time.slice(0,10);
      if(date != '0000-00-00')
      this.date = data.date_time.slice(0,10);
      this.name = data.name;
      this.purpose = data.purpose;
      this.mobile = data.mobile;
      this.valid_days = JSON.parse(data.valid_days);
      this.duration = data.duration;
      this.address = data.address;
      if(this.valid_days && this.valid_days.length > 0){
        this.isToggled = true;
        this.valid_days.forEach((val) => {
          this.days[val].isChecked = true;
        });
      }
      this.passNo = data.pass_no;
      console.log(this.date);
      console.log(this.time);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CreatePassPage');
  }

  onEvent(){
    let formData = this.generatePass();
    let loader = this.loadingCtrl.create({});

    if(this.validate()){
      return 0;
    }

    loader.present().then(() => {
      let data = this.navParams.get("passDetails")
      if(data){
        formData.id = data.id;
        this.visitorProvider.editPass(formData).then(val => {
          if(val.status == "success"){
            loader.dismiss();
            this.navParams.get("parentPage").refresh();
            this.navCtrl.pop();
          }else{
            loader.dismiss();
            this.toast.presentToast(val.message);
          }
        }).catch(() => {
          loader.dismiss();
          this.toast.presentToast("Service unavailable");
        });
      } else {
        this.visitorProvider.createPass(formData).then(val => {
          if(val.status == "success"){
            loader.dismiss();
            if(this.navParams.get("parentPage")){
              this.navParams.get("parentPage").refresh();
            }
            this.navCtrl.pop();
          }else{
            loader.dismiss();
            this.toast.presentToast(val.message);
          }
        }).catch(() => {
          loader.dismiss();
          this.toast.presentToast("Service unavailable");
        });
      }
    });
  }

  generatePass(){
    if(this.date && this.time){
      this.date_time = `${this.date} ${this.time}:00`;
    }
    if(this.time && this.isToggled){
      this.date_time = `0000-00-00 ${this.time}:00`;
    }
    //this.message = `Dear ${this.name},You have been invited by ${this.user_info.name} at ${this.user_info.society_name} [Flat number : ${this.user_info.flat_no}] on Date: ${this.date} and Time: ${this.time}`;
    this.residentId = this.user_info.id;
    this.status = 0;
    this.valid_days = [];
    if(this.isToggled){
      this.days.forEach((val, index, array) => {
        if(val.isChecked){
          this.valid_days.push(index.toString());
        }
      });
    }
    let formData: any = {
      dataSms: this.dataSms,
      date: this.date,
      date_time: this.date_time,
      duration: (this.duration)?this.duration:0,
      //message: this.message,
      mobile: this.mobile,
      name: this.name,
      purpose: this.purpose,
      residentId: this.residentId,
      status: this.status,
      time: this.time,
      valid_days: this.valid_days,
      address: this.address,
      image: this.image,
    };
    return formData;
  }

  validate(){
    if(!this.name){
      this.toast.presentToast("Name not provided");
      return true;
    }else if(!this.mobile){
      this.toast.presentToast("Mobile not provided");
      return true;
    }else if(this.mobile && String(this.mobile).length != 10){
      this.toast.presentToast("Invalid mobile no.");
      return true;
    }else if(!this.purpose){
      this.toast.presentToast("Purpose not provided");
      return true;
    }else if(!this.date_time){
      this.toast.presentToast("Date or time not provided");
      return true;
    }else if(this.duration && this.duration >24 ){
      this.toast.presentToast("Max. duration allowed is 24hrs.");
      return true;
    }else{
      return false;
    }
  }

  recurringVisit(){
    this.isToggled = !this.isToggled;
    console.log(this.isToggled);
  }

}



// WEBPACK FOOTER //
// ./src/pages/create-pass/create-pass.ts